import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import Hero from "@/components/home/Hero";
import { Squad, WhyBento, WaysToUse, SocialBand, B2BTeaser } from "@/components/home/Sections";

const BundleStrip = () => (
  <div className="relative z-10 -rotate-[0.5deg] bg-leaf py-3.5 text-white shadow-lg" data-testid="bundle-strip">
    <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-x-8 gap-y-1 px-4 text-center font-mono text-[11px] font-bold uppercase tracking-[0.2em] sm:text-xs">
      <span>Pick any 3 → 10% off</span>
      <span className="hidden text-forest sm:inline">✦</span>
      <span>Any 5+ → 15% off</span>
      <span className="hidden text-forest sm:inline">✦</span>
      <span>Auto-applied. No code. No nonsense.</span>
    </div>
  </div>
);

export default function Home() {
  const { data: products = [] } = useQuery({
    queryKey: ["products"],
    queryFn: async () => (await api.get("/products")).data,
  });

  return (
    <>
      <Hero />
      <BundleStrip />
      <Squad products={products} />
      <WhyBento />
      <WaysToUse />
      <SocialBand products={products} />
      <B2BTeaser />
    </>
  );
}
